// @flow

import * as React from 'react';

import styles from './POIFeature.less';

/** The component props for a <POIFeature> */
export type Props = {
  /** The icon name. See the <Icon/> component for valid names. */
  icon: string,

  /** The label to display next to the icon */
  label: string,
};

const POIFeature = ({ icon, label }: Props) => (
  <div className={styles.container}>
    <span className={`ui_icon ${icon} ${styles.icon}`} />
    <span className={styles.label}>{label}</span>
  </div>
);

export default POIFeature;
